"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*

    Social media
    
    All translations related to social media
    
    Verified by: Cédric Bloem
    Date: 12/12/2019
    identityBuilding bvba
    https://identitybuilding.be

*/
var SocialMedia = {
  osn_social: {
    nl: 'OSN#Social',
    fr: 'OSN#Social',
    en: 'OSN#Social'
  },
  socialMedia: {
    nl: 'Social media',
    fr: 'Social media',
    en: 'Social media'
  },
  post: {
    nl: 'Post',
    fr: 'Post',
    en: 'Post'
  },
  whatsapp: {
    nl: 'WhatsApp',
    fr: 'WhatsApp',
    en: 'WhatsApp'
  },
  skype: {
    nl: 'Skype',
    fr: 'Skype',
    en: 'Skype'
  },
  facebook: {
    nl: 'Facebook',
    fr: 'Facebook',
    en: 'Facebook'
  },
  twitter: {
    nl: 'Twitter',
    fr: 'Twitter',
    en: 'Twitter'
  },
  google: {
    nl: 'Google',
    fr: 'Google',
    en: 'Google'
  },
  youtube: {
    nl: 'YouTube',
    fr: 'YouTube',
    en: 'YouTube'
  },
  youtube_video: {
    nl: 'YouTube video',
    fr: 'YouTube vidéo',
    en: 'YouTube video'
  },
  vimeo: {
    nl: 'Vimeo',
    fr: 'Vimeo',
    en: 'Vimeo'
  },
  vimeo_video: {
    nl: 'Vimeo video',
    fr: 'Vimeo vidéo',
    en: 'Vimeo video'
  },
  linkedin: {
    nl: 'LinkedIn',
    fr: 'LinkedIn',
    en: 'LinkedIn'
  },
  pinterest: {
    nl: 'Pinterest',
    fr: 'Pinterest',
    en: 'Pinterest'
  },
  instagram: {
    nl: 'Instagram',
    fr: 'Instagram',
    en: 'Instagram'
  },
  tumblr: {
    nl: 'Tumblr',
    fr: 'Tumblr',
    en: 'Tumblr'
  },
  flickr: {
    nl: 'Flickr',
    fr: 'Flickr',
    en: 'Flickr'
  },
  snapchat: {
    nl: 'Snapchat',
    fr: 'Snapchat',
    en: 'Snapchat'
  },
  vine: {
    nl: 'Vine',
    fr: 'Vine',
    en: 'Vine'
  },
  dribbble: {
    nl: 'Dribbble',
    fr: 'Dribbble',
    en: 'Dribbble'
  },
  behance: {
    nl: 'Behance',
    fr: 'Behance',
    en: 'Behance'
  },
  foursquare: {
    nl: 'Foursquare',
    fr: 'Foursquare',
    en: 'Foursquare'
  },
  deviantart: {
    nl: 'Deviantart',
    fr: 'Deviantart',
    en: 'Deviantart'
  },
  wordpress: {
    nl: 'WordPress',
    fr: 'WordPress',
    en: 'WordPress'
  }
};
var _default = SocialMedia;
exports["default"] = _default;